import styled from 'styled-components';
import { Col, Row } from '../shared/styled';

export const IconRow = styled(Row)`
  align-items: center;
  background-color: ${props => props.theme.mainColor};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: ${props => props.theme.color};
  justify-content: space-between;
  padding: 5px 10px;
  width: 100%;
  h5 {
    color: ${props => props.theme.white};
    margin-bottom: 0;
  }
  svg {
    margin-right: 10px;
    width: 40px;
  }
`;

export const IconTitleSection = styled(Row)`
  
`;

export const PageSectionContainer = styled(Col)`
  width: 100%;
  :not(:last-child) {
    margin-bottom: 40px;
  }
  em {
    padding: 10px;
  }
`;